module.exports = __webpack_public_path__ + "Roboto-Bold.56a76a220d9c9765946d.ttf";


//////////////////
// WEBPACK FOOTER
// /app/~/roboto-fontface/fonts/Roboto/Roboto-Bold.ttf
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-Bold.ttf
// module chunks = 13